import { createFaviconUrl } from '@terminal/views/alfred/research/utils/createFaviconUrl';
import { v4 } from 'uuid';

export interface WebsiteInfo {
  id: string;
  title: string;
  url: string;
  favicon: string;
}

export const formatWebsiteInfo = (urls: string[]) =>
  urls.map(source => ({
    id: v4(),
    title: '',
    url: source,
    favicon: createFaviconUrl(source, 24),
  }));
